import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UserDataRoutingModule } from './user-data-routing.module';
import { UserDataComponent } from './user-data.component';

import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [
    UserDataComponent
  ],
  imports: [
    CommonModule,
    UserDataRoutingModule,
    TranslateModule
  ]
})
export class UserDataModule { }
